import _toConsumableArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Manual Conditional Rules Configuration
 *
 * This file contains conditional validation rules for fields that are missing
 * conditional_validations from the API response. These rules are merged with
 * the field schemas to provide complete validation coverage.
 *
 * Rules are evaluated as OR conditions - if any rule for a field triggers,
 * that field becomes required/optional/blank as specified.
 */

/**
 * Manual Conditional Rules
 *
 * TNM Staging Rules (M_Status, N_Status, T_Status):
 * - Applicable when Tissue_Diagnosis is populated, OR
 * - Applicable when Follow_Up_Diagnostic is 'PET/CT' (value '3')
 *
 * Overall Stage Rule:
 * - Applicable when Tissue_Diagnosis is 4, 7, or 8, OR
 * - Applicable when Follow_Up_Diagnostic is 'PET/CT' (value '3')
 *
 * Histology Non-Small Cell LC Rule:
 * - Cannot be '1 - Invasive adenocarcinoma' when Tissue_Diagnosis is 10 or 11
 * - When Tissue_Diagnosis is 10 or 11, only values in allowed_values list are permitted
 */
export var MANUAL_CONDITIONAL_RULES = [{
  field_name: "M_Status",
  conditional_validations: [{
    type: "optional",
    message: "M Status is applicable when Tissue Diagnosis is populated.",
    rule_id: "tnm.m_status.required_on_tissue_diagnosis",
    blocking: true,
    depends_on: "Tissue_Diagnosis",
    match_type: "not_empty",
    when_values: []
  }, {
    type: "optional",
    message: "M Status is applicable when Follow-up Diagnostic is PET/CT.",
    rule_id: "tnm.m_status.required_on_followup_petct",
    blocking: true,
    depends_on: "Follow_Up_Diagnostic",
    match_type: "in",
    when_values: ["3"]
  }]
}, {
  field_name: "N_Status",
  conditional_validations: [{
    type: "optional",
    message: "N Status is applicable when Tissue Diagnosis is populated.",
    rule_id: "tnm.n_status.required_on_tissue_diagnosis",
    blocking: true,
    depends_on: "Tissue_Diagnosis",
    match_type: "not_empty",
    when_values: []
  }, {
    type: "optional",
    message: "N Status is applicable when Follow-up Diagnostic is PET/CT.",
    rule_id: "tnm.n_status.required_on_followup_petct",
    blocking: true,
    depends_on: "Follow_Up_Diagnostic",
    match_type: "in",
    when_values: ["3"]
  }]
}, {
  field_name: "T_Status",
  conditional_validations: [{
    type: "optional",
    message: "T Status is applicable when Tissue Diagnosis is populated.",
    rule_id: "tnm.t_status.required_on_tissue_diagnosis",
    blocking: true,
    depends_on: "Tissue_Diagnosis",
    match_type: "not_empty",
    when_values: []
  }, {
    type: "optional",
    message: "T Status is applicable when Follow-up Diagnostic is PET/CT.",
    rule_id: "tnm.t_status.required_on_followup_petct",
    blocking: true,
    depends_on: "Follow_Up_Diagnostic",
    match_type: "in",
    when_values: ["3"]
  }]
}, {
  field_name: "Overall_Stage",
  conditional_validations: [{
    type: "optional",
    message: "Overall Stage is applicable when Tissue Diagnosis is Positive, Invasive cancer, or Metastatic cancer.",
    rule_id: "staging.overall_stage.applicable_on_tissue_diagnosis",
    blocking: true,
    depends_on: "Tissue_Diagnosis",
    match_type: "in",
    when_values: ["4", "7", "8"]
  }, {
    type: "optional",
    message: "Overall Stage is applicable when Follow-up Diagnostic is PET/CT.",
    rule_id: "staging.overall_stage.applicable_on_followup_petct",
    blocking: true,
    depends_on: "Follow_Up_Diagnostic",
    match_type: "in",
    when_values: ["3"]
  }]
}, {
  field_name: "Histology_Non_Small_Cell_LC",
  conditional_validations: [{
    type: "blank",
    message: "Histology Non-Small Cell LC cannot be 'Invasive adenocarcinoma' when Tissue Diagnosis is 'Malignant - not adenocarcinoma, lung cancer'.",
    rule_id: "histology.non_small_cell_lc.not_invasive_adenocarcinoma",
    blocking: true,
    depends_on: "Tissue_Diagnosis",
    match_type: "in",
    when_values: ["10", "11"],
    // Allowed values: all valid histology codes except "1" (Invasive adenocarcinoma)
    // Adjust this list based on actual field schema if needed
    allowed_values: ["2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "88", "99"]
  }]
}];

/**
 * Merges manual conditional rules with field schemas
 * Adds conditional_validations to fields that are missing them from API
 */
export var mergeManualRules = function mergeManualRules(fieldSchemas) {
  return fieldSchemas.map(function (schema) {
    var manualRule = MANUAL_CONDITIONAL_RULES.find(function (rule) {
      return rule.field_name === schema.field_name;
    });
    if (manualRule) {
      var _schema$metadata;
      return _objectSpread(_objectSpread({}, schema), {}, {
        metadata: _objectSpread(_objectSpread({}, schema.metadata), {}, {
          conditional_validations: [].concat(_toConsumableArray(((_schema$metadata = schema.metadata) === null || _schema$metadata === void 0 ? void 0 : _schema$metadata.conditional_validations) || []), _toConsumableArray(manualRule.conditional_validations))
        })
      });
    }
    return schema;
  });
};